<template>
    <div>
        <transition name="ani-slide-in">
        <cl-comp></cl-comp>
        </transition>
    </div>
</template>

<script>
    import ChecklisComponent from "../components/modules/checklist/ChecklisComponent";
    export default {
        name: "Checklist",
        components: {
            ClComp : ChecklisComponent}
    }
</script>

<style scoped>

</style>